module.exports = "\n        <multiselect-dropdown\n        [settings]=\"ddSettings\"\n        [data]=\"availableItems\"\n        [(ngModel)]=\"selectedDDOptions\"\n        (onSelect)=\"selectionChanged()\"\n        (onDeSelect)=\"selectionChanged()\"\n        (onSelectAll)=\"selectionChanged()\"\n        (onDeSelectAll)=\"selectionChanged()\">\n      </multiselect-dropdown>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/global/confidence-picker/confidence-picker.component.html
// module id = ./client/app/global/confidence-picker/confidence-picker.component.html
// module chunks = main